import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import Index from "./pages/Index";
import Projects from "./pages/Projects";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Management from "./pages/Management";
import About from "./pages/About";
import ProjectFolders from "./pages/qr/ProjectFolders";
import MediaExplorer from "./pages/qr/MediaExplorer";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminGuard from "./auth/AdminGuard";
import ErrorBoundary from "@/components/ErrorBoundary";

const queryClient = new QueryClient();

const AppRoutes = () => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-[#2A2A2A] text-[#E0E0E0] px-6">
          <div className="max-w-md text-center space-y-3">
            <h1 className="text-2xl font-semibold">{t('errors.appCrashTitle')}</h1>
            <p className="text-sm text-[#B5B5B5]">{t('errors.appCrashBody')}</p>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/management" element={<Management />} />
        <Route path="/about" element={<About />} />
        <Route path="/p/:slug" element={<ProjectFolders />} />
        <Route path="/p/:slug/images" element={<MediaExplorer />} />
        <Route path="/p/:slug/videos" element={<MediaExplorer />} />
        <Route path="/p/:slug/panos" element={<MediaExplorer />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin/login" element={<Navigate to="/login" replace />} />
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ErrorBoundary>
  );
};

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Sonner />
        <AppRoutes />
      </TooltipProvider>
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
